import { useState, useEffect } from "react"
import { fetchGetDatawithID } from "../../../lib/fetchGetDatawithID"
import "../../styles/pages/Adm/global.adm.styles.css"
import { ButtonCenter } from "../../components/adm/ButtonCenter"
import { fetchUpdateData } from "../../../lib/fetchUpdateData"

export const EditWhatsApp = () => {
    const [whatsAppSupport, setWhatsAppSupport] = useState([])
    const id = "feujICDNSbtiliWy7onU"
    const collectionName = "whatsappsupport"

    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchGetDatawithID({ collectionName: collectionName, id: id })
            setWhatsAppSupport(data)
        }
        fetchData()
    }, [])

    async function handleSubmit(e) {
        e.preventDefault()
        try {
            await fetchUpdateData({
                id: id,
                data: whatsAppSupport,
                collectionName: collectionName
            })
            alert("Atualizado")
        } catch (error) {
            alert("erro:", error)
        }
    }

    function handleInputChange(e) {
        let { name, value } = e.target
        setWhatsAppSupport((prevClass) => ({ ...prevClass, [name]: value }))
    }

    function handleInputCheckboxChange(e) {
        const { checked } = e.target
        setWhatsAppSupport({ active: checked })
    }

    return (
        <>
            <ButtonCenter
                homeBtn={true}
            />
            <div className="div-adm-center">
            <form className="form-adm" onSubmit={handleSubmit}>
                Controle do WhatsApp
                <input
                        type="text"
                        placeholder="Número"
                        name="number"
                        value={whatsAppSupport.number}
                        onChange={handleInputChange}
                />
                <label className="active-whats-label">
                    {whatsAppSupport.active ? "O WhatsApp está ativo" : "O WhatsApp Não está ativo"}
                    <input 
                        type="checkbox"
                        name="active"
                        checked={whatsAppSupport.active}
                        onChange={handleInputCheckboxChange}
                    />
                </label>
                <button type="submit"> Salvar </button>
            </form>
            </div>
        </>
    )
}